import { css } from '@emotion/react';

export const LINE_80_10 = css`
  border-bottom: 1px solid var(--gray-80);
`;

export const LINE_100_10 = css`
  border-bottom: 1px solid var(--gray-100);
`;

export const LINE_100_10_CARD = css`
  height: 30px;
  background-color: white;
  box-shadow: inset 0 -1px 0 0 var(--gray-200);
`;

export const SPACE = css`
  height: 8px;
  background-color: var(--gray-60);
`;

export const SPACE_LINE = css`
  height: 8px;
  background-color: var(--gray-60);
  border-top: 1px solid var(--gray-100);
  border-bottom: 1px solid var(--gray-80);
`;

export const typeStyles = {
  LINE_80_10,
  LINE_100_10,
  LINE_100_10_CARD,
  SPACE,
  SPACE_LINE,
};

export const wrapper = (
  type: 'LINE_80_10' | 'LINE_100_10' | 'LINE_100_10_CARD' | 'SPACE' | 'SPACE_LINE'
) => css`
  width: 100%;
  border: 0;
  margin: 0;
  ${typeStyles[type]};
`;
